import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CallToAction = makeShortcode("CallToAction");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Before proceeding, let's make sure events are being captured and sent to PostHog. You should see `}<inlineCode parentName="p">{`cta clicked`}</inlineCode>{` events appear in the `}<strong parentName="p">{`Activity`}</strong>{` feed.`}</p>
    <CallToAction className="my-2" size="sm" type="secondary" to="https://app.posthog.com/activity/explore" external={true} mdxType="CallToAction">
  Check for events in PostHog
    </CallToAction>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      